(function () {
  var root = document.querySelector('[data-mn-vpop]');
  if (!root) return;

  try {
    window.sessionStorage.removeItem('mn_video_popup_off');
  } catch (e) {}

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mn-vpop-card]'));
  if (!cards.length) return;

  var closeBtn = root.querySelector('[data-mn-vpop-close]');
  var prevBtn = root.querySelector('[data-mn-vpop-prev]');
  var nextBtn = root.querySelector('[data-mn-vpop-next]');
  var current = 0;
  var visible = false;
  var timer;
  var rotateMs = 9000;
  var snoozeMs = 28000;
  var firstShowMs = 8000;

  if (cards.length < 2) {
    if (prevBtn) prevBtn.hidden = true;
    if (nextBtn) nextBtn.hidden = true;
  }

  function trustOpen() {
    var trust = document.querySelector('[data-mn-trust]');
    return !!(trust && trust.classList.contains('is-open') && !trust.hidden);
  }

  function drawerOpen() {
    return document.documentElement.classList.contains('m-cart-drawer-open') ||
      !!document.querySelector('.m-cart-drawer--active');
  }

  function pauseCard(card) {
    if (!card) return;
    var video = card.querySelector('video');
    var iframe = card.querySelector('[data-mn-vpop-iframe]');
    if (video) video.pause();
    if (iframe) iframe.removeAttribute('src');
    card.classList.remove('is-playing');
    card.hidden = true;
  }

  function playCard(card) {
    if (!card) return;
    card.hidden = false;
    var video = card.querySelector('video');
    var iframe = card.querySelector('[data-mn-vpop-iframe]');
    if (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(function () {
          card.classList.add('is-playing');
        }).catch(function () {});
      } else {
        card.classList.add('is-playing');
      }
    }
    if (iframe && iframe.dataset.src) {
      iframe.src = iframe.dataset.src;
      card.classList.add('is-playing');
    }
    if (!video && !iframe) card.classList.add('is-playing');
  }

  function showSlide(index) {
    if (!cards.length) return;
    pauseCard(cards[current]);
    current = (index + cards.length) % cards.length;
    playCard(cards[current]);
  }

  function hidePopup() {
    visible = false;
    root.classList.add('is-closing');
    root.classList.remove('is-open');
    pauseCard(cards[current]);
    window.setTimeout(function () {
      root.hidden = true;
      root.classList.remove('is-closing');
    }, 280);
  }

  function openPopup() {
    if (trustOpen() || drawerOpen()) {
      schedule(8000);
      return;
    }
    root.hidden = false;
    window.requestAnimationFrame(function () {
      root.classList.add('is-open');
      showSlide(current);
      visible = true;
    });
    schedule(rotateMs);
  }

  function schedule(ms) {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      if (!visible) {
        openPopup();
        return;
      }
      showSlide(current + 1);
      schedule(rotateMs);
    }, ms);
  }

  function onNav(step, event) {
    event.preventDefault();
    event.stopPropagation();
    if (!visible) return;
    showSlide(current + step);
    schedule(rotateMs);
  }

  if (prevBtn) prevBtn.addEventListener('click', function (event) { onNav(-1, event); });
  if (nextBtn) nextBtn.addEventListener('click', function (event) { onNav(1, event); });

  if (closeBtn) {
    closeBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      hidePopup();
      current = current + 1;
      schedule(snoozeMs);
    });
  }

  root.addEventListener('click', function (event) {
    if (event.target.closest('.mn-vpop__nav, .mn-vpop__close')) return;
    var link = event.target.closest('a.mn-vpop__link');
    if (link && link.href && link.getAttribute('href') !== '#') {
      event.preventDefault();
      window.location.href = link.href;
    }
  });

  schedule(firstShowMs);
})();
